import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faHome,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi } from "../helpers/useApi";
import { Model } from "../components/Model";
import { SelectBox } from "../components/SelectBox";
import { Textbox } from "../components/Textbox";

export const Company = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const [showModel, setShowModel] = useState(false);

  const [states, setStates] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  const [city, setCity] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
    loadStates();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (isTyping) {
        setIsTyping(false);
        getData(1);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handlePageChange = (newPage) => {
    getData(newPage);
  };

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Company + `?${queryParams}`
      );
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  };

  const handleView = (id) => {
    // alert("Not Set")
    navigate(Routess.Company.path + `/${id}`);
  };

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  const submitForm = async (data) => {
    if (data == null) return;
    // console.log("data", data)
    try {
      const payload = {
        companyName: data.companyName,
        cityID: parseInt(data.city, 10) || 0,
        stateID: parseInt(data.state, 10) || 0,
        address: data.address || "",
        branchTitle: data.branchName || "",
        branchCode: data.branchCode,
        jurisdiction: data.jurisdiction || "",
        transportRegNumber: data.transportRegNumber || "",
        email: data.email,
        mobile: data.mobile,
        website: data.website,
        gstNumber: data.gstNumber,
        panNumber: data.panNumber,
        firstName: data.firstName,
        lastName: data.lastName,
        userEmail: data.useremail,
        userPhone: data.userMobile,
      };

      const response = await callApi(API_URL_ENDPOINT.Company, {
        method: "POST",
        data: payload,
      });
      if (response.status) {
        setShowModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const loadStates = async () => {
    try {
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${states.pageNo}`,
        `pageSize=${states.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.States + `?${queryParams}`
      );
      if (response.status) {
        setStates(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      setDataLoading(false);
    }
  };

  const getCities = async (stateid) => {
    try {
      //clear existing city
      setCity({
        items: [],
        pageNo: 1,
        pageSize: 50,
        totalPage: 0,
        totalRecords: 0,
      });
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      if (stateid) filters.push(`StateID:${stateid}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${city.pageNo}`,
        `pageSize=${city.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Cities + `?${queryParams}`
      );
      if (response.status) {
        setCity(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      // setDataLoading(false);
    }
  };

  return (
    <>
      <Model show={showModel} size={"xl"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Company</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submitForm)}>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Company Name"
                    name={"companyName"}
                    Placeholder="Company Name"
                    validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Branch Name"
                    name={"branchName"}
                    Placeholder="Branch Name"
                    validationRules={{ required: "Branch Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Branch Code"
                    name="branchCode"
                    Placeholder="Branch Code"
                    validationRules={{
                      required: "Branch Code is required",
                      pattern: {
                        value: /^[A-Z]{3,4}$/,
                        message:
                          "Branch Code must be 3 or 4 uppercase letters only",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="State"
                    name={"state"}
                    validationRules={{ required: "State is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                    onChange={(e) => getCities(e.target.value)}
                  >
                    <option value={""} selected>
                      Select State
                    </option>
                    {states?.items.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.stateName}
                      </option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="City"
                    name={"city"}
                    validationRules={{ required: "City is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""} selected>
                      Select City
                    </option>
                    {city?.items.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.cityName}
                      </option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Address"
                    name={"address"}
                    Placeholder="Address"
                    validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Jurisdiction"
                    name={"jurisdiction"}
                    Placeholder="Jurisdiction"
                    validationRules={{ required: "Jurisdiction is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
                            <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="GST Number"
                    name={"gstNumber"}
                    Placeholder="15 Digit GST Number"
                    validationRules={{
                      required: "GST Number is required",
                      pattern: {
                        value:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Invalid GST Number",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="PAN Number"
                    name={"panNumber"}
                    Placeholder="PAN Number"
                    validationRules={{
                      required: "PAN Number is required",
                      pattern: {
                        value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        message: "Invalid PAN Number",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Transport Reg. Number"
                    name={"regNumber"}
                    Placeholder="Transport Reg. Number"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Email"
                    name={"email"}
                    Placeholder="Email"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mobile"
                    name={"mobile"}
                    Placeholder="Mobile"
                    validationRules={{ required: "Mobile Number is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Website"
                    name={"website"}
                    Placeholder="Website"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <p>Add Admin Detail</p>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="First Name"
                    name={"firstName"}
                    Placeholder="First Name"
                    validationRules={{
                      required: "First Name is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Last Name"
                    name={"lastName"}
                    Placeholder="Last Name"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Email"
                    name={"useremail"}
                    Placeholder="Email"
                    validationRules={{
                      required: "Email is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mobile Number"
                    name={"userMobile"}
                    Placeholder="Mobile"
                    validationRules={{
                      required: "Mobile Number is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button type="submit" disabled={isSubmitting} variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Company</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Company</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Button
            onClick={() => setShowModel(true)}
            className="me-2 d-block"
            variant="primary"
            style={{ whiteSpace: "nowrap" }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Company
          </Button>
          <Form.Control
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsTyping(true);
            }}
            type="text"
            className="shadow-none"
            placeholder={"Search..."}
          />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
            </div>
          ) : (
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Company Name</th>
                  <th className="border-0 text-center">Reg. Number</th>
                  <th className="border-0 text-center">GST</th>
                  <th className="border-0 text-center">PAN</th>
                  <th className="border-0 text-center">Email</th>
                  <th className="border-0 text-center">Mobile</th>
                  <th className="border-0 text-center">Website</th>
                  <th className="border-0 text-center">Jurisdiction</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.companyName || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.transportRegNumber || "-"}
                      </td>
                      <td className="fw-bold align-middle text-cemter">
                        {item.gstNumber}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.panNumber}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.email || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.mobile || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.website || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.jurisdiction || "-"}
                      </td>
                      <td className="text-end align-middle">
                        <Button
                          variant="primary"
                          className="btn-sm"
                          onClick={() => handleView(item.id)}
                        >
                          View Details
                        </Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination
              totalPages={data.totalPage}
              loading={dataLoading}
              onPageChange={handlePageChange}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
